// extracted by mini-css-extract-plugin
module.exports = {"comments":"post-module--comments--1alRg","customMedia":{},"customProperties":{},"customSelectors":{}};